import styled from "styled-components";
import {motion} from "framer-motion";

const Wipe = styled(motion.div)`
    position: fixed;
    inset: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    pointer-events: none;
    background-color: ${({theme}) => theme.backgroundColor};
    background-image: radial-gradient(60% 60% at 50% 50%, rgba(214, 218, 225, 0.10), transparent 70%);
`

const Logo = styled(motion.img)`
    width: min(220px, 34vw);
    height: auto;
    object-fit: contain;
`

export const Styled = {
    Wipe,
    Logo
}
